import axios from 'axios';

export const getUrl = (type) => {
    let url = '';

    if (typeof process.env.API_URL !== 'undefined') {
        url = process.env.API_URL
    } else if (process.env.NODE_ENV === 'development') {
        url = 'http://api.localhost';
    } else {
        url = 'https://cheetah-api.builderall.com';
    }

    if (type === 'api') {
        return url + '/api';
    }

    return url;
};

const getUrlProd = (type) => {
  let url = 'https://cheetah-api.builderall.com';

  if (type === 'api') {
    return url + '/api';
  }

  return url;
};

const http = new function () {
  this.api = function () {
    return axios.create({
      baseURL: getUrl('api'),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    });
  };

  this.webAction = function () {
    return axios.create({
      baseURL: getUrl('web'),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    });
  };

  this.authApi = function () {
    var token = localStorage.getItem('token')
      ? localStorage.getItem('token')
      : '';

    return axios.create({
      baseURL: getUrl('api'),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    });
  };

  this.authApiV2 = function () {
    var token = localStorage.getItem('token')
      ? localStorage.getItem('token')
      : '';

    return axios.create({
      baseURL: getUrl('api') + '/v2',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    });
  };

  this.authProd = function () {
    var token = localStorage.getItem('tokenP')
      ? localStorage.getItem('tokenP')
      : '';

    return axios.create({
      baseURL: getUrlProd('api'),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    });
  };
}();

export default http;



// WEBPACK FOOTER //
// ./src/js/services/http.js